import { SettingsUsersUserDto } from '../interfaces';
import { generateMockListResult } from '../../../lib';
import { mockUserFields } from './userMockFields';

export const getSettingsUsersMockUsers = (options: { page: number; pageSize: number; totalCount?: number }) => {
    const { page = 0, pageSize = 10, totalCount = 51 } = options;

    return generateMockListResult<SettingsUsersUserDto>({
        fields: mockUserFields,
        page,
        pageSize,
        totalCount,
    });
};
